import React from "react";
import { Alert, Container } from "reactstrap";
import GridBody from "./Grid/GridBody";
import withRouter from "../../components/Common/withRouter";
import { DF_OT0015Context } from "./context";

function DF_OT0015(props) {
  document.title = "Defender | Dados do Agendamento";
  const location = props.router.location;
  const parseParams = new URLSearchParams(location.search);

  if (!parseParams.get("ID_Agendamento") || !parseParams.get("ID_Arquivo")) {
    return (
      <Alert color="danger">
        Não é possível acessar essa transação sem parâmetros
      </Alert>
    );
  }

  return (
    <>
      {/* eslint-disable-next-line react/jsx-pascal-case */}
      <DF_OT0015Context.Provider
        value={{
          idAgendamento: parseParams.get("ID_Agendamento"),
          idArquivo: parseParams.get("ID_Arquivo"),
        }}
      >
        <div className="page-content">
          <Container fluid={true} className="dataTable-custom-primary">
            <GridBody />
          </Container>
        </div>
      </DF_OT0015Context.Provider>
    </>
  );
}

export default withRouter(DF_OT0015);
